import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, FormHelperText, Box, Stack, Chip, Grid } from '@mui/material';

import SiteService from './SiteService';
import MainMeterSelector from './MainMeterSelector';


const SubMeterSelector = ({ mainMeterId, setMainMeterId, setMainMeter, subMeterId, setSubMeterId }) => {
  const [subMeters, setSubMeters] = useState([]);
  const [singleMainMeterName, setSingleMainMeterName] = useState('');
  const [singleSubMeterName, setSingleSubMeterName] = useState('');

  // MainMeter değiştiğinde SubMeter'ları çek
  useEffect(() => {
    if (mainMeterId) {
      SiteService.getSubMetersByMainMeter(mainMeterId).then((res) => {
        setSubMeters(res.data);
        if (res.data.length === 1) {
          setSubMeterId(res.data[0].subMeterId); // Tek SubMeter varsa otomatik seç          
          setSingleSubMeterName(res.data[0].name);
        } else {
        setSubMeterId(null);
        console.log('subMeter temiz');
        setSingleSubMeterName('');
      }
      });
    } else {
      setSubMeters([]); // MainMeter seçilmezse subMeters temizle
    }
  }, [mainMeterId]);

  return (
<Box p={1}>
  <Grid container spacing={2} alignItems="center">
    <Grid item xs="auto">
      <MainMeterSelector
        mainMeterId={mainMeterId}
        setMainMeterId={setMainMeterId}
        setMainMeter={setMainMeter}
      />
    </Grid>
    <Grid item xs="auto">
      {singleSubMeterName ? (
        <Chip
          label={`Süzme Sayaç: ${singleSubMeterName}`}
          color="success"
          variant="outlined"
          
        />
      ) : (
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Seçilen Süzme Sayaç</InputLabel>
          <Select
            value={subMeterId}
            onChange={(e) => setSubMeterId(e.target.value)}
            label="Seçilen Süzme Sayaç"
          >
            {subMeters.map((subMeter) => (
              <MenuItem key={subMeter.subMeterId} value={subMeter.subMeterId}>
                {subMeter.name}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>İşlem yapmak istediğiniz Alt Sayacı seçin</FormHelperText>
        </FormControl>
      )}
    </Grid>
  </Grid>
</Box>

  );
};

export default SubMeterSelector;
